module.exports = __webpack_public_path__ + "00e791854b736942ee6999537d0491d2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/imageslider/slider-04.jpg
 ** module id = 26
 ** module chunks = 0
 **/